import {
  emailFieldSchema,
  nameFieldSchema,
  realDateFieldSchema,
  selectFieldSchema,
} from 'utils/schema.util'
import { isCpf } from 'utils/validate.util'
import { z } from 'zod'
import { addressInit, addressSchema } from './address.type'
import { ERROR_MESSAGE_CPF_INCORRECT } from './error.type'

const cpfFieldSchema = z
  .string()
  .refine(isCpf, {
    message: ERROR_MESSAGE_CPF_INCORRECT,
  })
  .nullish()

export const personReferenceSchema = z.object({
  id: z.number().nullish(),
  nome: nameFieldSchema,
  dataNascimento: realDateFieldSchema.nullish(),
  cpf: cpfFieldSchema,
  identidade: z.string().nullish(),
})

export const referenceTypeSchema = z.object({
  id: selectFieldSchema,
  descricao: z.string().nullish(),
})

export const familiarReferenceSchema = z.object({
  id: z.number().nullish(),
  pessoaReferencia: personReferenceSchema,
  tipoReferencia: referenceTypeSchema,
  descricaoProfissao: z.string().nullish(),
  descricaoRendaBeneficio: z.string().nullish(),
  telefone: z.string().nullish(),
  email: emailFieldSchema.nullish(),
  informacaoComplementar: z.string().nullish(),
  endereco: addressSchema,
})

export type PersonReferenceSchemaType = z.infer<typeof personReferenceSchema>

export type ReferenceType = z.infer<typeof referenceTypeSchema>

export type FamiliarReferenceType = z.infer<typeof familiarReferenceSchema>

export const personReferenceInit: PersonReferenceSchemaType = {
  id: null,
  nome: '',
  dataNascimento: '',
  cpf: '',
  identidade: '',
}

export const referenceTypeInit: ReferenceType = {
  id: '0',
  descricao: '',
}

export const familiarReferenceInit: FamiliarReferenceType = {
  id: null,
  pessoaReferencia: personReferenceInit,
  tipoReferencia: referenceTypeInit,
  descricaoProfissao: '',
  descricaoRendaBeneficio: '',
  telefone: '',
  email: '',
  informacaoComplementar: '',
  endereco: addressInit,
}
